var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.browser.caption))]),_c('ol',{staticClass:"card-text"},_vm._l((_vm.getSteps(_vm.browser.name)),function(step){return _c('li',{key:step},[_vm._v(" "+_vm._s(_vm.getStepContent(_vm.browser.name, step))+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }